import React from 'react';

function Footer(props) {
    return (
        <div>

            <footer className="page-footer">

                <div className="footer-copyright">
                    <div className="container">
                        © {new Date().getFullYear()} Copyright Text
                        <a className="grey-text text-lighten-4 right" href="#!">REPO</a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;